export default function MySQL_FLOOR() {
  return (
    <div>
      <h2>MySQL_FLOOR</h2>    </div>
  );
}